import React from "react";

const BG = "#0E0B08";
const PANEL = "#1D1712";
const BORDER = "#3D3122";
const GOLD = "#C9A15A";
const TEXT_MUTED = "#B3A48D";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Queda visible en la consola del navegador para diagnosticar.
    console.error("PP Cacao — error atrapado:", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ background: BG, minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24, fontFamily: "'Inter','Segoe UI',sans-serif" }}>
          <div style={{ maxWidth: 420, width: "100%", background: PANEL, border: `1px solid ${BORDER}`, borderRadius: 16, padding: 24, textAlign: "center" }}>
            <div style={{ fontSize: 34, marginBottom: 10 }}>😬</div>
            <div style={{ fontWeight: 800, fontSize: 17, color: "#F4EFE6", marginBottom: 8 }}>Algo salió mal</div>
            <div style={{ fontSize: 13, color: TEXT_MUTED, marginBottom: 18 }}>
              No perdiste tu información — ocurrió un error inesperado en la pantalla.
              Intenta recargar la página.
            </div>
            <button
              onClick={() => window.location.reload()}
              style={{ background: GOLD, color: "#1A140C", border: "none", borderRadius: 10, padding: "12px 20px", fontWeight: 700, fontSize: 14, cursor: "pointer" }}
            >
              Recargar
            </button>
            <div style={{ fontSize: 10, color: TEXT_MUTED, marginTop: 16, opacity: 0.7, wordBreak: "break-word" }}>
              {String(this.state.error?.message || this.state.error)}
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
